import { executeRequest, HTTP_METHODS } from "@/common/utils/http/httpClient";

export async function getEvents() {
  return await executeRequest(
    {
      url: `/assets/mocks/events.json`,
      method: HTTP_METHODS.GET
    },
    false
  );
}
